export class GenerateShippingGuideReportInput {
    orderIds: number[];
}